import { emptyFragment } from '@execonline-inc/execonline-ui';
import { AlreadyTranslatedText } from '@execonline-inc/translations';
import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import { Experience } from '../../../Common/Experience/Types';
import {
  ExperienceDetailsSection,
  ExperienceDetailsSectionHeader,
} from '../ExperienceDetailsSection';
import ExperienceHtmlView from '../ExperienceHtmlView';

interface Props<T> {
  experience: T;
}

function ExperienceWhatYouWillLearn<
  T extends { keyTakeawaysHtml: Maybe<AlreadyTranslatedText> } = Experience,
>({ experience }: Props<T>) {
  return experience.keyTakeawaysHtml
    .map((data) => (
      <ExperienceDetailsSection data-intercom-target="experience-what-you-will-learn-section">
        <ExperienceDetailsSectionHeader title="What you will learn" />
        <ExperienceHtmlView
          className="!text-sm [&>ul]:grid [&>ul]:gap-3 sm:[&>ul]:grid-cols-2 sm:[&>ul]:gap-8"
          data={data}
        />
      </ExperienceDetailsSection>
    ))
    .getOrElse(emptyFragment);
}

export default observer(ExperienceWhatYouWillLearn);
